import Footer from "../../Footer/Footer";
import Header from "../../Header/Header";
import React, { useState } from 'react';
import BlockContent from "../../Block/BlockContent";
import BlockTitle from "../../Block/BlockTitle";
import BlockSubtitle from "../../Block/BlockSubtitle";
import BlockText from "../../Block/BlockText";
import Block from "../../Block/Block";
import './Blank.css';

function Blank() {
  const numberOfDivs = 3744;
  const divsArray = Array.from({ length: numberOfDivs });

  const [date, setDate] = useState("1980-01-01");
  const [weeksPassed, setWeeksPassed] = useState(weeksSince(date));


    function weeksSince(date) {
        const currentDate = new Date();
        const givenDate = new Date(date);
        const millisecondsPerWeek = 1000 * 60 * 60 * 24 * 7;
    
        const differenceInMilliseconds = currentDate - givenDate;
        const weeksPassed = Math.floor(differenceInMilliseconds / millisecondsPerWeek);
    
        return weeksPassed;
    }

    const handleDateChange = (event) => {
        setDate(event.target.value);
    };
    
    const handleDateSubmit = () => {
        setWeeksPassed(weeksSince(date));
    };

  //const weeksPassed = weeksSince("1992-09-20");


  return (
    <div>
      <Header/>        

      <div style={{backgroundImage:'url("/Home/pointwave.webp")', 
                  height:"200px",
                  width: "100%",
                  backgroundSize: "100% 100%",
                  backgroundPosition: "bottom"}}>
      </div>

      <Block colorTheme="light" gridTemplateColumns="1200px">
        <BlockContent width="100%">
          <BlockTitle>LifeTick</BlockTitle>
          <BlockSubtitle>Ever wanted to know how many weeks you still have left? No? Never mind. Here’s the answer to the question you never asked. Have fun!</BlockSubtitle>
          <div>
            <input 
              type="date" 
              value={date} 
              onChange={handleDateChange} 
            />
            <button onClick={handleDateSubmit}>Set Date</button>
          </div>
          <BlockSubtitle>{weeksPassed} / {numberOfDivs} Weeks</BlockSubtitle>
          <BlockSubtitle>{(weeksPassed / numberOfDivs * 100).toFixed(4)} %</BlockSubtitle>
        </BlockContent>
      </Block>

      <Block colorTheme="dark" gridTemplateColumns="1200px">
        <BlockContent width="100%">
        <div className="div-container">
            {divsArray.map((_, index) => (
              <div 
                key={index} 
                className={`square ${index <= weeksPassed ? 'black' : ''}`}
              ></div>
            ))}
          </div>

        </BlockContent>
      </Block>
      

      <Footer/>
                 
    </div>
  );
}

export default Blank;
